<ng-container>
  <div class="signing-details">
    @if(!shouldShowSessionHandoff()) {
    <h1>Welcome to your signing!</h1>
    }
    <app-signing-details-card *appMobileOnly></app-signing-details-card>
  </div>

  @if (isSigningAgent()) {
  <app-signing-agent-welcome-page></app-signing-agent-welcome-page>
  } @else if (shouldShowSessionHandoff()) {
  <app-session-handoff-page></app-session-handoff-page>
  } @else {
  <app-non-signing-agent-welcome-page>
    @if (hasMultipleSigners()) {
    <app-alert-banner-expand
      (buttonAction)="copyLink()"
      [buttonName]="alertBannerButtonText"
      [header]="alertBannerHeader"
      [isDisabled]="isAlertButtonDisabled"
      [isExpanded]="isNotMobile()"
      [type]="type"
      class="alert-banner"
    >
      <p class="alert-banner__message">
        Signers can share a device or use their own. If another signer needs the closing link to
        join on a separate device, share the link below. You can continue signing on this device.
      </p>
    </app-alert-banner-expand>
    }
  </app-non-signing-agent-welcome-page>
  }
</ng-container>
<app-package-status-monitor></app-package-status-monitor>
